import axios from 'axios';

export class ReporteService {

    get() {
        return axios.get('assets/data/000000.json').then(res => res.data);
        //return axios.get('http://resultadoshistorico.onpe.gob.pe/v1/EG2021/results/10/000000?name=param').then(res => res.data);
        
    }
    get2026() {
        return axios.get('assets/data/000001.json').then(res => res.data);
        //return axios.get('http://resultadoshistorico.onpe.gob.pe/v1/EG2021/results/10/000000?name=param').then(res => res.data); 
    }
    getInfo() {
        return axios.get('assets/data/000002.json').then(res => res.data);
        //return axios.get('http://resultadoshistorico.onpe.gob.pe/v1/EG2021/results/10/000000?name=param').then(res => res.data); 
    }

}